export default {
    navigationBarTitleText: ''
  };
  